import { render, staticRenderFns } from "./assumptions.vue?vue&type=template&id=377b3ce2&scoped=true"
import script from "./assumptions.vue?vue&type=script&lang=js"
export * from "./assumptions.vue?vue&type=script&lang=js"
import style0 from "./assumptions.vue?vue&type=style&index=0&id=377b3ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377b3ce2",
  null
  
)

export default component.exports